/* eslint-disable */
(function ($, Drupal) {
  Drupal.behaviors.lastguideb5 = {
    attach(context, settings) {

      // $(document).ready(function(){
      //   let details = $('.region-nav-search details');
      //   details.each(function () {
      //     var attr = $(this).attr('open');
      //     if (typeof attr !== 'undefined' && attr !== false) {
      //       $(this).removeAttr('open');
      //     }
      //   })
      // })

      // set the
      let paragraphStep = $('.paragraph-type--step')
      paragraphStep.each(function (index) {
        $(this).find('.paragraph-type-label').html(`Étape <span class="step-number">${index + 1}</span>`)
      })


      $('.password').attr('type','password')
      // Rate widget code
      $('.user-not-logged-in .rate-widget');
      $('.user-not-logged-in .rate-widget').click(() => {
        const path = window.location.pathname;
        const t = path.split('/');
        const langcode = t[1] == 'fr' ? `/${t[1]}` : '';
        const redirect = `${langcode}/user/login?destination=${path}`;
        window.location.replace(redirect);
      });

      $(document).ready(() => {
        // Remove empty section on user page.
        const promotionUserHtml = $('.block-views-blockuser-profile-block-3 .block-content .view-user-profile').html();
        if (promotionUserHtml) {
          if (promotionUserHtml.length < 300) {
            $('.block-views-blockuser-profile-block-3').hide();
          }
        }

        // Search
        const search_block = $('.region-nav-search form');
        const search_advanced = search_block.find(' .card-body-base-wrapper');
        const search_filters = search_block.find('.form-type-checkbox, .form-type-radio');
        const search_cards = search_advanced.find(' > .card');
        search_advanced.addClass('cb-container-w');
        menu_changes();
        search_apply_html();
        search_text_field_input();
        search_show_selected_filters();
        footer_limit_cards();
        search_modal_height();
        $('.block-views-exposed-filter-blockrecherche-search-api-page-1 .card-header.bg-light').on('click', () => {
          setTimeout(() => {
            search_modal_height();
          }, 1000);
        });
        search_apply_reset_filters();
        $('body').find('.form-type-checkbox, .form-type-radio').on('click', function () {
          const parent_card = $(this).closest('.card');
          if ($(this).hasClass('form-type-radio')) {
            parent_card.find('.form-type-radio').removeClass('is-checked');
          }
          if ($(this).find('input').is(':checked')) {
            $(this).addClass('is-checked');
          } else {
            $(this).removeClass('is-checked');
          }
          search_show_selected_filters();
        });

        // Manage Arrow State on Search Categories
        $('.card-body .card .card-header').on('click', function () {
          if ($(this).parent().find('.card-body').is(':visible')) {
            $(this).removeClass('open');
          } else {
            $(this).addClass('open');
          }
          search_modal_height();
        });

        // choosing filters in advanced search
        $('body').on('click', '.my-filters .filter-selected label', function () {
          search_apply_remove_filter_item(this);
          search_modal_height();
        });

        $('body').on('click', '.block-views-blockcards-footer-block-1 .view-footer > a', function (e) {
          e.preventDefault();
          $('.site-footer .block-views-blockcards-footer-block-1 > .block-content ul.nav li').show();
          $(this).hide();
        });

        // open submenus from main menu
        if (typeof (context.doctype) !== 'undefined' || $('body').hasClass('user-not-logged-in')) { // #document object, not ajax call
          // open advanced search
          $('.navbar-toggler-search').click(() => {
            if (typeof $('.bef--secondary').attr('open') !== 'undefined') {
              $('.bef--secondary').removeAttr('open');
            } else {
              $('.bef--secondary').attr('open', '');
            }
            $('#header, .navbar-collapse-main, .navbar-secondary').removeClass('show');
            $('.navbar-secondary').removeClass('clicked');
          });

          // close main menu when opening advanced search
          $('body').on('click', '.bef--secondary > .card-header', () => {
            $('#header, .navbar-collapse-main, .navbar-secondary').removeClass('show');
            $('.navbar-secondary').removeClass('clicked');
          });

          $('.dropdown a').click(function () {
            if (!$(this).hasClass('etape-link')) {
              if ($(window).width() >= 768) {
                const h5title = $(this).text();
                const parent = $(this).parent();
                $(this).addClass('show');
                parent.siblings().find('dropdown-menu').removeClass('show');
                parent.siblings().find('> a').removeClass('show');
                const html = $(this).next('.dropdown-menu')[0].outerHTML;
                if (h5title == $('body').find('.navbar-secondary').find('.sub-title').html()) { // the same submenu
                  $('body').find('.navbar-secondary').toggleClass('show');
                } else if ($('body').find('.navbar-secondary').hasClass('show')) { // another submenu is opened
                  $('body').find('.navbar-secondary').removeClass('show').removeClass('clicked');
                  setTimeout(() => {
                    $('body').find('.navbar-secondary .block-menu').html(html);
                    $('body').find('.navbar-secondary').addClass('show').addClass('clicked');
                  }, 10);
                } else {
                  $('body').find('.navbar-secondary .block-menu').html(html);
                  $('body').find('.navbar-secondary').addClass('show').addClass('clicked');
                }
              }
            }

          });

          $('.navbar-toggler-main').on('click', () => {
            $('.navbar-collapse-main').addClass('clicked');
            $('.navbar-secondary').removeClass('show').removeClass('clicked');
            $('body').find('details[id^="edit-secondary"]').removeAttr('open');
          });

          $(window).on('resize', () => {
            menu_changes();
            footer_limit_cards();
            search_modal_height();
          });

          $('body').on('click', () => {
            $('#header, .navbar-collapse-main, .navbar-secondary').removeClass('show');
            $('.navbar-secondary').removeClass('clicked');
            $('body').find('details[id^="edit-secondary"]').removeAttr('open');
            if (jQuery('body').find('.navbar-collapse-user').hasClass('show')) {
              jQuery('.navbar-toggler-user').click();
            }
          });

          $('#header, .navbar-collapse-main, #edit-secondary > .card-body, .navbar-secondary').on('click', (event) => {
            event.stopPropagation();
          });

          // adjust menu height when opening toolbar
          $('#toolbar-bar').on('click', () => {
            menu_changes();
          });

          // wrap Contribue/Lastguide in footer menu
          const items = $('.region-footer-right .menu--footer .navbar-nav > li:nth-child(1), .region-footer-right .menu--footer .navbar-nav > li:nth-child(2)');
          items.wrapAll('<div class="left-align"/>');
        }

        // main menu changes on page load/resize
        function menu_changes() {
          let height_toolbar = 0;
          if ($('#toolbar-bar').length > 0) {
            height_toolbar += $('#toolbar-bar').height();
          }
          if ($('.toolbar-tray.is-active').length > 0) {
            height_toolbar += $('.toolbar-tray.is-active').height() + 2;
          }

          $('.navbar-collapse-main .nav-item.dropdown').each(function () {
            const title = $(this).find('> a').clone();
            $(this).find('> .dropdown-menu').children('.sub-title').html(title);
          });

          if ($('.nav-main--wrapper .navbar-secondary').length == 0) {
            $('.nav-main--wrapper').append('<div class="navbar-secondary"><div class="block-menu"></div></div>');
          }

          $('.region-nav-main .navbar-nav > li > span').each(function () {
            const parent = $(this).parent();
            $(this).removeAttr('data-bs-toggle').removeClass('dropdown-toggle');
            parent.addClass('opened');
            parent.find('> ul').removeClass('dropdown-menu').addClass('submenu');
            parent.find('> ul > .sub-title').remove();
          });

          $('.navbar-collapse-main ul li a').on('click', function () {
            const menuWidth = $(this).closest('.navbar-collapse-main').width();
            $('.nav-main--wrapper .navbar-secondary').css('left', `${menuWidth}px`);
          });
        }

        // advanced search changes
        function search_text_update_input_form(searchString) {
          const input = $(search_block).find('.card-body-base-wrapper .form-text');
          if (!$(input).is(':visible')) {
            $(input).val(searchString);
          }
        }

        function search_text_field_input() {
          $(search_block).find('.form-text').on('keydown', function () {
            search_text_update_input_form($(this).val());
          });

          $(search_block).on('submit', () => {
            search_text_update_input_form($(search_block).find('.form-text').val());
          });
        }

        function search_apply_html() {
          // add "enregistrer" button
          if (search_advanced.find('.btn-action-section').length == 0) {
            search_advanced.append(`<div class="btn-action-section"><div class="reset-btm-wp reset-wp"><a href="#" class="reset-icon reset-filter-btn reset-filter">${Drupal.t('Annuler')}</a></div>` + '<input type="submit" id="edit-submit-recherche-search-api-secondary" value="Recherchez" class="button js-form-submit form-submit btn btn-primary rounded-pill px-6 py-2">' + '</div>');
          }
          // add "Mes filters"
          if (search_advanced.find('.my-filters').length == 0) {
            search_advanced.prepend(`${'<div class="my-filters">' + '<div class="my-filters-wp"><span class="filter-lbl">'}${Drupal.t('Mes filtres')}</span><div class="details-wrapper card-body"></div></div>` + '<div class="reset-icon-wp reset-wp"><a href="#" class="reset-icon reset-filter-icon reset-filter"></a></div>' + '</div>');
          }
          // add search input field for mobile
          if (search_advanced.find('.form-type-textfield').length == 0) {
            search_advanced.prepend('<div class="form-type-textfield">' + '<input type="text" id="edit-s" name="s" value="" size="30" maxlength="128" placeholder="Rechercher un projet…" class="form-text form-control rounded-pill"></div>');
          }
        }

        /* Remove Filter */
        function search_apply_remove_filter_item(item) {
          const id = $(item).attr('for');
          const current_card = $(`#${id}`).closest('.card');
          $(`#${id}`).prop('checked', false);
          $(`#${id}`).parent().removeClass('is-checked');
          $(item).parent().remove();

          const count = current_card.find('input[value!="All"]:checked').length;

          if (count > 0) {
            current_card.find('.card-header .summary').html(`(${count})`);
          } else {
            current_card.find('.card-header .summary').html('');
          }

          if ($('.my-filters .filter-selected').length == 0) {
            $('.my-filters').removeClass('filters-active').hide();
          }
        }

        /* Apply reset filter on search filters */
        function search_apply_reset_filters() {
          $('.my-filters .reset-filter').on('click', () => {
            const filters = $('.my-filters .filter-selected');
            filters.each(function () {
              const label = $(this).find('label');
              search_apply_remove_filter_item(label);
            });
          });

          $('.btn-action-section .reset-filter').on('click', () => {
            $('.bef--secondary').removeAttr('open');
            $('#edit-secondary').removeAttr('open');
          });

        }

        /* show selected filters in advanced search, display count of filters for each filter group */
        function search_show_selected_filters() {
          let selected_filters = '';
          search_filters.each(function () {
            if ($(this).find('input:checked').val() == 'All') {
              $(this).find('input:checked').parent().hide();
            }
            if ($(this).find('input:checked').length > 0 && $(this).find('input:checked').val() !== 'All') {
              $(this).addClass('is-checked');
              const label = $(this).find('label')[0].outerHTML;
              selected_filters += `<div class="filter-selected category-selected">${label}</div>`;
            }
          });
          if (selected_filters.length > 0) {
            $('.my-filters').addClass('filters-active').show();
          } else {
            $('.my-filters').removeClass('filters-active').hide();
          }
          $('.my-filters .card-body').html(selected_filters);

          search_cards.each(function () {
            const count = $(this).find('input[value!="All"]:checked').length;
            if (count > 0) {
              $(this).find('.card-header .summary').html(`(${count})`);
            } else {
              $(this).find('.card-header .summary').html('');
            }
          });

          search_modal_height();
        }

        // limit cards in footer (mobile)
        function footer_limit_cards() {
          const width = $(document).width();
          if (width < 768) {
            $('.site-footer .block-views-blockcards-footer-block-1 > .block-content ul.nav li').each(function (index) {
              if (index > 7) {
                $(this).hide();
              }
            });
          } else {
            $('.site-footer .block-views-blockcards-footer-block-1 > .block-content ul.nav li').show();
          }
        }

        // Add class to update style height on search modal
        function search_modal_height() {
          const windowHeight = $(window).height() - 120;
          const cardBody = $('#views-exposed-form-recherche-search-api-page-1 .details-wrapper.card-body-base');
          const cardBodyW = $('#views-exposed-form-recherche-search-api-page-1 .card-body-base-wrapper');
          const cardBodyWHeight = cardBodyW.height();

          if (windowHeight < cardBodyWHeight) {
            cardBody.addClass('mh-scroll').css('height', windowHeight + 10);
          } else {
            cardBody.removeClass('mh-scroll').css('height', '');
          }
        }
      });
    },
  };
  // }
}(jQuery, Drupal));
